import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as ForwardRef } from '../../../../../assets/icons/DragHandlerSmall.svg.js';
import Hint from '../../../../Hint/Hint.js';

const DragHandler = (_a) => {
    var { isDragging, visibility } = _a, rest = __rest(_a, ["isDragging", "visibility"]);
    return (jsx(Hint, Object.assign({ title: !isDragging ? 'Reorder columns' : '' }, { children: jsx("div", Object.assign({ className: "drag-icon", "data-testid": "drag-handler", style: { visibility } }, rest, { children: jsx(ForwardRef, {}) })) })));
};

export { DragHandler as default };
//# sourceMappingURL=DragHandler.js.map
